// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__Pa+W+","header":"style_header__reRNz","icon":"style_icon__tCrJI","description":"style_description__kQ0Fv","content":"style_content__awuqE"};